import * as selectors from './groups.selectors';
import reducer from './groups.reducers';

export default reducer;
export { selectors, reducer };
export { GroupAction } from './groups.actions';
export { GroupEffects } from './groups.effects';
export { GroupState, Group } from './groups.models';
export { GroupService } from './groups.service';
